export default {
  namespaced: true,
  state: {
    activeElement: null,
    activeGroup: null
  },
  mutations: {
    SET_ACTIVE_ELEMENT(state, data) {
      state.activeElement = data 
    },
    SET_ACTIVE_GROUP(state, data) {
      state.activeGroup = data 
    }
  },
  actions: {
    UPDATE_ACTIVE_ELEMENT({ commit }, data) {
      commit('SET_ACTIVE_ELEMENT', data) 
    },
    UPDATE_ACTIVE_GROUP ({ commit }, data) {
      commit('SET_ACTIVE_GROUP', data) 
    }
  },
  getters: {
    activeElement: state => state.activeElement,
    activeGroup: state => state.activeGroup
  }
}